import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import useTranslate from 'modules/local/useTranslate'
import {NotificationActionTypes, successNotify,} from '../../factory/createNotification'
import {
    product_addVariant_Api,
    product_createNew_Api,
    product_delete_Api,
    product_deleteVariant_Api,
    product_editVariant_Api,
    product_publish_Api,
    product_update_Api
} from "../../../../apis";
import {NullAsDefault} from "../../../Shared";
import {notifyOnError} from "../../factory/createErrorEvent";

const useProductActions = ({
                               notifyListeners = {
                                   onRefresh: undefined,
                                   onCancel: undefined
                               },
                           }) => {
    const t = useTranslate()

    const {
        onRefresh = NullAsDefault,
        onCancel = NullAsDefault
    } = notifyListeners ?? {}

    const onError = notifyOnError(t)

    const {handleAsyncAction: createNewProduct} = useAsyncAction({
        apiInfo: product_createNew_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.CREATE, t)
            onRefresh()
        },
    })

    const {handleAsyncAction: editProductInfo} = useAsyncAction({
        apiInfo: product_update_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.UPDATE, t)
            onCancel()
        },
    })

    const {handleAsyncAction: deleteProduct} = useAsyncAction({
        apiInfo: product_delete_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.DELETE, t)
            onRefresh()
        },
    })

    const {handleAsyncAction: publishProduct} = useAsyncAction({
        apiInfo: product_publish_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.UPDATE, t)
            onCancel()
        },
    })


    const {handleAsyncAction: addVariant} = useAsyncAction({
        apiInfo: product_addVariant_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.CREATE, t)
            onRefresh()
        },
    })

    const {handleAsyncAction: editVariantInfo} = useAsyncAction({
        apiInfo: product_editVariant_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.UPDATE, t)
            onCancel()
        },
    })

    const {handleAsyncAction: deleteVariant} = useAsyncAction({
        apiInfo: product_deleteVariant_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.DELETE, t)
            onRefresh()
        },
    })


    return {
        createNewProduct,
        editProductInfo,
        deleteProduct,
        publishProduct,
        addVariant,
        editVariantInfo,
        deleteVariant
    }
}

export default useProductActions
